import { apiRequest } from 'api/apiClient';
import {
  buildPageModuleContentPayload,
  buildPageModuleName,
  buildPageModuleType,
} from '../utils/pageModulePayload';

function constructSocialUrls(socialIds) {
  const socials = ['facebook', 'instagram', 'x', 'tiktok', 'pinterest'];
  const socialUrls = {};

  // eslint-disable-next-line no-restricted-syntax
  for (const social of socials) {
    if (socialIds[social]) {
      switch (social) {
        case 'tiktok':
          socialUrls[social] = `https://tiktok.com/@${socialIds[social]}`;
          break;
        default:
          socialUrls[social] = `https://${social}.com/${socialIds[social]}`;
      }
    } else {
      socialUrls[social] = null;
    }
  }

  return socialUrls;
}

const updateStore = async (values) => {
  const socialIds = {
    facebook: values.facebook,
    instagram: values.instagram,
    x: values.x,
    tiktok: values.tiktok,
    pinterest: values.pinterest,
  };

  const socialUrls = constructSocialUrls(socialIds);

  const { facebook, instagram, x, tiktok, pinterest, ...otherValues } = values;
  const updatedValues = { ...otherValues, ...socialUrls };

  const response = await apiRequest('PUT', '/v1/retailer-page/me', updatedValues);
  return response;
};

const addPageModule = async ({ module_type, name, content }) => {
  const transformedContent = buildPageModuleContentPayload(module_type, content);
  const moduleName = buildPageModuleName(module_type, name);
  const apiModuleType = buildPageModuleType(module_type);

  const response = await apiRequest('POST', '/v1/page-modules', {
    module_type: apiModuleType,
    name: moduleName,
    ...transformedContent,
  });
  return response;
};

const updatePageModule = async ({ moduleUid, moduleType, name, content }) => {
  const moduleName = buildPageModuleName(moduleType, name);
  const transformedContent =
    content === undefined ? {} : buildPageModuleContentPayload(moduleType, content);

  const response = await apiRequest('PATCH', `/v1/page-modules/${moduleUid}`, {
    name: moduleName,
    ...transformedContent,
  });
  return response;
};

const removePageModule = async (uid) => {
  const response = await apiRequest('DELETE', `/v1/page-modules/${uid}`);
  return response;
};

const movePageModule = async ({ uid, before, after }) => {
  const response = await apiRequest('PATCH', `/v1/page-modules/${uid}/move`, {
    ...(before ? { before } : {}),
    ...(after ? { after } : {}),
  });
  return response;
};

const STORE_MUTATIONS = {
  UPDATE_STORE: updateStore,
  ADD_PAGE_MODULE: addPageModule,
  UPDATE_PAGE_MODULE: updatePageModule,
  REMOVE_PAGE_MODULE: removePageModule,
  MOVE_PAGE_MODULE: movePageModule,
};

export default STORE_MUTATIONS;
